import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

// Components - Auth
import Login from './components/auth/Login';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';

// Components - Quality Control
import Dashboard from './components/quality-control/Dashboard';
import CaptureWithTabs from './components/quality-control/CaptureWithTabs';
import Reporter from './components/quality-control/Reporter';
import Acciones from './components/quality-control/Acciones';

// Components - Admin
import Users from './components/admin/Users';
import Sites from './components/admin/Sites';
import Catalogs from './components/admin/Catalogs';
import Permissions from './components/admin/Permissions';

// Components - Conversion
import OrdersData from './components/conversion/OrdersData';
import Employees from './components/conversion/Employees';
import ConversionCapture from './components/conversion/ConversionCapture';
import ConversionAnalytics from './components/conversion/ConversionAnalytics';
import ConversionPdfReports from './components/conversion/ConversionPdfReports';
import ScheduledReports from './components/conversion/ScheduledReports';

// Components - Common
import Sidebar from './components/Sidebar';
import ProtectedRoute from './components/common/ProtectedRoute';
import About from './components/common/About';

// Context
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import { SiteProvider } from './context/SiteContext';

// Styles
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <SiteProvider>
          <Router>
          <div className="App app-with-sidebar">
            <Sidebar />
            <main className="main-content">
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/dashboard" element={<ProtectedRoute permissions={["dashboard:view"]}><Dashboard /></ProtectedRoute>} />
                <Route path="/reporter" element={<ProtectedRoute permissions={["reports:view"]}><Reporter /></ProtectedRoute>} />
                <Route path="/capture" element={<ProtectedRoute permissions={["capture:create"]}><CaptureWithTabs /></ProtectedRoute>} />
                <Route path="/sites" element={<ProtectedRoute permissions={["sites:manage"]}><Sites /></ProtectedRoute>} />
                <Route path="/users" element={<ProtectedRoute permissions={["users:manage"]}><Users /></ProtectedRoute>} />
                <Route path="/catalogs" element={<ProtectedRoute permissions={["catalogs:manage"]}><Catalogs /></ProtectedRoute>} />
                <Route path="/acciones" element={<ProtectedRoute permissions={["actions:manage"]}><Acciones /></ProtectedRoute>} />
                <Route path="/permissions" element={<ProtectedRoute permissions={["permissions:view"]}><Permissions /></ProtectedRoute>} />
                <Route path="/orders-data" element={<ProtectedRoute permissions={["conversion:view", "conversion:ordersdata"]}><OrdersData /></ProtectedRoute>} />
                <Route path="/employees" element={<ProtectedRoute permissions={["conversion:employees"]}><Employees /></ProtectedRoute>} />
                <Route path="/conversion" element={<ProtectedRoute permissions={["conversion:view"]}><ConversionCapture /></ProtectedRoute>} />
                <Route path="/conversion/analytics" element={<ProtectedRoute permissions={["conversion:analytics"]}><ConversionAnalytics /></ProtectedRoute>} />
                <Route path="/conversion/reportes-pdf" element={<ProtectedRoute permissions={["conversion:reportespdf"]}><ConversionPdfReports /></ProtectedRoute>} />
                <Route path="/conversion/reportes-programados" element={<ProtectedRoute permissions={["conversion:automatic_report_viewanduse"]}><ScheduledReports /></ProtectedRoute>} />
                <Route path="/about" element={<ProtectedRoute><About /></ProtectedRoute>} />
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </main>
            <Toaster position="top-right" />
          </div>
        </Router>
        </SiteProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
